module.exports = __webpack_public_path__ + "img/oth7.551fbce4.png";